import React, { useReducer } from "react";
import portalReducer from "./portalReducer";
import portalContext from "./portalContext";
import axios from "axios";

import {
    GET_DASHBOARD_DATA,
    ERROR_GET_DATA,
    CLOSE_SESION,
    GET_DASHBOARDBILL_RESPONSE,
    PORTAL_SET_IS_BILL
} from "../../types";
import axiosClient from "../../config/axios";
import tokenAuth from "../../config/token";

const PortalState = (props) => {
  const initialState = {
    data: null,
    terminals: [],
    error: false,
    sessionExpired: false,
    loading: true,
  };

  const [state, dispatch] = useReducer(portalReducer, initialState);

  const getDashboardData = async () => {
    //console.log('getDashboardData')
    try {
        tokenAuth(localStorage.getItem('token'))
      const response = await axiosClient.post("/dashboard");

      dispatch({
        type: GET_DASHBOARD_DATA,
        payload: response.data.data,
      });
    } catch (error) {
      if (error.response&&error.response.status === 401) {
        dispatch({
          type: CLOSE_SESION,
          payload: "La sesiòn ha caducado, por favor haga login nuevamente", //error.message,
        });
      }
      else {
        dispatch({
          type: ERROR_GET_DATA,
          payload: "Ha ocurrido un error al cargar los datos.", //error.message,
        });
      }

    }
  };

  const getDashboardBill = async () => {
    //console.log('getDashboardBill')
    try {
      tokenAuth(localStorage.getItem('token'))
      const response = await axiosClient.get("/dashboardBill")
      dispatch({
        type: GET_DASHBOARDBILL_RESPONSE,
        payload: response.data.data
      });
      return true;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        dispatch({
          type: CLOSE_SESION,
          payload: "La sesiòn ha caducado, por favor haga login nuevamente", //error.message,
        });
      }
      else {
        dispatch({
          type: ERROR_GET_DATA,
          payload: "Ha ocurrido un error al cargar los datos.", //error.message,
        });
      }

    }
  };

  const setIsBill=(isBill)=>{
    dispatch({
          type: PORTAL_SET_IS_BILL,
          payload: {isBill},
        });
  }
  return (
    <portalContext.Provider
      value={{
        data: state.data,
        loading: state.loading,
        sessionExpired: state.sessionExpired,
        error: state.error,
        isBill:state.isBill??null,
        terminals: state.terminals,
        getDashboardData,
        getDashboardBill,
        setIsBill
      }}
    >
      {props.children}
    </portalContext.Provider>
  );
};

export default PortalState;
